"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = require("../../components/Icons/index");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AddRemoveButton = function AddRemoveButton(_ref) {
  var added = _ref.added,
      onClick = _ref.onClick,
      className = _ref.className,
      CustomAdd = _ref.customAdd,
      CustomRemove = _ref.customRemove,
      otherProps = _objectWithoutProperties(_ref, ["added", "onClick", "className", "customAdd", "customRemove"]);

  return /*#__PURE__*/_react.default.createElement(Button, _extends({
    className: className,
    onClick: onClick
  }, otherProps), !added ? CustomAdd ? /*#__PURE__*/_react.default.createElement(CustomAdd, null) : /*#__PURE__*/_react.default.createElement(_index.IconActionPlus, {
    className: "plus",
    size: 20
  }) : CustomRemove ? /*#__PURE__*/_react.default.createElement(CustomRemove, null) : /*#__PURE__*/_react.default.createElement(_index.IconMinus, {
    className: "minus",
    size: 20
  }));
};

var Button = _styledComponents.default.button.withConfig({
  displayName: "Button"
})(["padding:0;border:0;background-color:#f0f1f3;width:24px;height:24px;display:flex;justify-content:center;align-items:center;border-radius:5px;cursor:pointer;transition:background-color 0.15s ease-in-out;svg.plus path{fill:#8990a3;transition:fill 0.15s ease-in-out;}svg.minus line{stroke:#8990a3;transition:stroke 0.15s ease-in-out;}&:hover{background-color:", ";svg.plus path{fill:white;}svg.minus line{stroke:white;}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.brand.primary;
});

AddRemoveButton.defaultProps = {
  added: false
};
AddRemoveButton.propTypes = {
  /** Set to true if the remove state should be shown. */
  added: _propTypes.bool.isRequired,

  /** onClick function to be executed when the button is clicked. */
  onClick: _propTypes.func,

  /** Extra className to be added to the button. */
  className: _propTypes.string,

  /** A custom add component */
  customAdd: _propTypes.func,

  /** A custom remove component */
  customRemove: _propTypes.func,

  /** Extra props. */
  otherProps: _propTypes.object
};
var _default = AddRemoveButton;
exports.default = _default;